import React, { Component } from 'react';
import { Helmet } from "react-helmet";

import { raids } from 'data/raids';

import Wrap from 'components/Wrap';
import RaidBossCard from 'components/RaidBossCard';

class RaidDirectory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchQuery: '',
      typeFilter:  null,
      sortBy: 'tier',
      sortOrder: 1
    }

    this.clearFilters = this.clearFilters.bind(this);
    this.filterSearch = this.filterSearch.bind(this);
    this.filterType = this.filterType.bind(this);
    this.sortBy = this.sortBy.bind(this);
  }

  clearFilters(event) {
    this.setState({
      searchQuery: '',
      typeFilter:  null,
      sortBy: 'number',
      sortOrder: 1
    })
  }

  filterSearch(event) {
    this.setState({
      searchQuery: event.target.value.toLowerCase()
    })
  }

  filterType(event) {
    this.setState({
      typeFilter: event.target.value
    })
  }

  sortBy(event) {
    event.preventDefault();
    event.target.parentNode.querySelectorAll('[data-sort-order]').forEach((button) => {
      if(button !== event.target) {
        button.dataset.sortOrder = button.dataset.initialSortOrder;
        button.classList.remove('active');
      }
    })
    event.target.dataset.sortOrder *= -1;
    event.target.classList.add('active');

    this.setState({
      sortBy: event.target.dataset.sortBy,
      sortOrder: event.target.dataset.sortOrder
    })
  }

  render() {
    let filteredRaids = raids;

    // Search
    filteredRaids = filteredRaids.filter((raid) => {
      return raid.name.toLowerCase().search(this.state.searchQuery.toLowerCase()) !== -1;
    });

    // Type filter
    if(this.state.typeFilter) {
      filteredRaids = filteredRaids.filter((raid) => {
        return raid.type.includes(this.state.typeFilter);
      });
    }

    // Sort
    filteredRaids = filteredRaids.sort((a, b) => {
      let sortResult = -1;

      switch(this.state.sortBy) {
        case 'name':
          let aName = a.name.toLowerCase();
          let bName = b.name.toLowerCase();
          if(aName > bName) {
            sortResult = 1
          } else if(aName < bName) {
            sortResult = -1;
          } else {
            sortResult = 0;
          }
          break;
        default:
          sortResult = (a[this.state.sortBy] - b[this.state.sortBy]);
      }

      return sortResult * this.state.sortOrder;
    })

    return (
      <div id="RaidDirectory" className="RaidDirectory">
        <Helmet>
          <link rel="canonical" href={"http://pokego.fyi/raids/"} />
          <title>Pokemon Go Raids & Raid Bosses · pokego.fyi</title>
          <meta name="description" content="Raids are here in Pokemon Go! Battle powerful Raid Bosses for a chance to capture them!" />
        </Helmet>

        <Wrap>

          <form className="wrap:s m-x:a m-b:s">
            <div className="Sorter  wrap:s m-x:a m-t:xs  d:f jc:c ai:c  ts:tiny">
              <span className="flg:0 p:xs p-l:0 c:dark-pewter">Sort By:</span>
              <button className="active flg:1 appearance:n ln:0  bgc:xlight-pewter bd:0 bd-r:m bdc:light-pewter m:0 p:xs rad-tl:pill  c:dark-pewter hv(c:black)" data-sort-by="tier" data-initial-sort-order="-1" data-sort-order="1" onClick={this.sortBy}>Tier</button>
              <button className="flg:1 appearance:n ln:0  bgc:xlight-pewter bd:0 bd-r:m bdc:light-pewter m:0 p:xs  c:dark-pewter hv(c:black)" data-sort-by="name" data-initial-sort-order="-1" data-sort-order="-1" onClick={this.sortBy}>Name</button>
              <button className="flg:1 appearance:n ln:0  bgc:xlight-pewter bd:0 bdc:light-pewter m:0 p:xs  c:dark-pewter hv(c:black)" data-sort-by="bossCaptureRate" data-initial-sort-order="1" data-sort-order="1" onClick={this.sortBy}>Capture %</button>
              <button className="flg:1 appearance:n ln:0  bgc:xlight-pewter bd:0 bdc:light-pewter m:0 p:xs  c:dark-pewter hv(c:black)" data-sort-by="bossCp" data-initial-sort-order="1" data-sort-order="1" onClick={this.sortBy}>CP</button>
            </div>
          </form>

          <div className="wrap:s m-x:a">
            {filteredRaids.map((raid) => {
              return (
                <div className="d:f fld:r  bd-b:m bdc:light-pewter  bgc:white" key={raid.name}>
                  <div className="flg:1">
                    <RaidBossCard raid={raid} />
                  </div>
                </div>
              );
            })}

            {(filteredRaids.length === 0) && (
              <div className="p:m  ta:c bgc:white">
                <span className="c:pewter ts:small">No Raid Bosses Found</span>
              </div>
            )}
          </div>

        </Wrap>
      </div>
    );
  }
}

export default RaidDirectory;



// WEBPACK FOOTER //
// ./src/scenes/RaidDirectory.js